import { TermSheetPlaceholders } from './constants'

export const validatePlaceholders = (
  value: string,
  additionalPlaceholders: string[] = [],
  checkOnlyAddon: boolean = false,
  checkOpenEnd: boolean = true,
) => {
  const regex = /\{\{(.*?)\}\}/g
  const placeholders = value.match(regex)
  const opens = value.match(/\{\{/g)
  const ends = value.match(/\}\}/g)

  const errorPlaceholders: string[] = []

  let hasError = false

  if (!!placeholders) {
    const matchedPlaceholders = placeholders.map((item: string) => item.replace(/\{\{|\}\}/g, ''))

    matchedPlaceholders.forEach((item: string) => {
      if (![...(checkOnlyAddon ? [] : TermSheetPlaceholders), ...additionalPlaceholders].includes(item)) {
        errorPlaceholders.push(item)
        hasError = true
      }
    })
  }

  if (checkOpenEnd) {
    if (!!opens) {
      if (!ends) hasError = true
      else if (opens.length !== ends.length) hasError = true
    } else if (!!ends) hasError = true
  }

  return { hasError, errorPlaceholders }
}
